// Client config storage keys
export const authTokenKeyStorageKey = 'authTokenKey';
export const envStorageKey = 'env';
export const clientConfigCheckCycleStorageKey = 'clientConfigCheckCycle';
export const userSyncPollCycleStorageKey = 'userSyncPollCycle';
export const applicationSyncPollCycleStorageKey = 'applicationSyncPollCycle';

// Client clock compensation storage keys
export const apiClockTimestampStorageKey = 'apiTimestamp';
export const clientClockTimestampStorageKey = 'clientTimestamp';
